<template>
  <section class="service-section">
    <div class="service-container">
      <ServicePackagesSidebar />
      <div class="content-col">
        <ServicePackageContent
        title="Custom E–Commerce Website Development"
        startingPrice="$79,999"
        :overview="overview"
        :bullets="bullets"
        cta-route="/schedule-a-meeting"
      />
      <MobileServicePackagesList />

      </div>
    </div>
  </section>
</template>

<script>
import ServicePackagesSidebar from '@/views/servicePackages/ServicePackagesSidebar.vue';
import ServicePackageContent from '@/views/servicePackages/ServicePackageContent.vue';
import MobileServicePackagesList from '@/views/servicePackages/MobileServicePackagesList.vue';

export default {
  name: 'CustomEcommerceDevelopment',
  components: { ServicePackagesSidebar, ServicePackageContent, MobileServicePackagesList },
  data() {
    return {
      overview:
        'For businesses with advanced e-commerce requirements beyond Shopify, we design and build a fully custom e-commerce platform. This package is built for enterprises and scaling brands with unique catalogs, complex checkout workflows, and deep integrations — with no compromises on flexibility or performance.',
      bullets: [
        'Custom product catalog architecture with dedicated database',
        'Advanced checkout flows (subscriptions, multi-currency, split payments, etc.)',
        'ERP, CRM, or third-party system integrations',
        'Tailored reporting, analytics, and dashboards',
        'A secure, scalable infrastructure built for long-term growth',
      ],
    };
  },
};
</script>

<style scoped>
.service-section { padding: 2rem 1rem; background: #f9fafb; }

/* Two-column layout: fixed 380px sidebar + flexible content */
.service-container {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 380px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

/* Wrap content and ensure it can shrink without overflow */
.content-col { min-width: 0; }

/* One-column at ≤768px (sidebar hidden by its own CSS) */
@media (max-width: 768px) {
  .service-container {
    grid-template-columns: 1fr;
  }
}
</style>